// extracted by mini-css-extract-plugin
module.exports = {"noTitle":"index_noTitle__31FGu"};